import { apiRequest, setTokens } from "./api";

function isEmail(value) {
  return /\S+@\S+\.\S+/.test(value);
}

export function isValidMobile(value) {
  return /^[6-9]\d{9}$/.test(value);
}

export async function loginWithPassword(identifierRaw, password) {
  const identifier = identifierRaw.trim();
  const result = isValidMobile(identifier)
    ? await apiRequest("/auth/login/mobile", {
        method: "POST",
        body: { mobileNumber: identifier, password },
      })
    : await apiRequest("/auth/login", {
        method: "POST",
        body: { identifier, password },
      });

  setTokens(result.access_token, result.refresh_token);
  return result;
}

export async function sendLoginOtp(identifier) {
  return apiRequest("/auth/login/otp/send", {
    method: "POST",
    body: { identifier: identifier.trim() },
  });
}

export async function verifyLoginOtp(identifier, otp) {
  const result = await apiRequest("/auth/login/otp/verify", {
    method: "POST",
    body: { identifier: identifier.trim(), otp },
  });
  setTokens(result.access_token, result.refresh_token);
  return result;
}

export async function initiateSocialLogin(provider, redirectUri) {
  return apiRequest("/auth/login/social/initiate", {
    method: "POST",
    body: { provider, redirectUri },
  });
}

export async function completeSocialLogin(provider, code, state) {
  const result = await apiRequest("/auth/login/social/callback", {
    method: "POST",
    body: { provider, code, state },
  });
  setTokens(result.access_token, result.refresh_token);
  return result;
}

export { isEmail };
